import { createContext } from 'react';
import type { User } from 'firebase/auth';

export type Role = 'owner' | 'admin' | 'editor' | 'viewer' | 'seller' | 'operator';

export interface Membership {
  orgId: string;
  orgName: string;
  orgType: 'partner' | 'personal';
  role: Role;
}

export interface SessionState {
  status: 'loading' | 'signed-out' | 'signed-in';
  user: User | null;
  memberships: Membership[];
  activeOrg: Membership | null;
  setActiveOrg: (orgId: string) => void;
  refreshMemberships: () => Promise<void>;
  logout: () => Promise<void>;
}



export const SessionContext = createContext<SessionState | null>(null);
